module.exports = __webpack_public_path__ + "img/picto-tel-round.15e431d2.svg";